import { createPortal } from 'react-dom'

type Props = {
  isVisible: boolean
  addedProductName: string
}

export const ProductAddedMessage = (props: Props) => {
  return createPortal(
    <div>
      <div
        className={`fixed top-60 w-auto md:w-96 h-fit bottom bg-[#00B67A] text-white transform transition-transform duration-500 z-10 rounded-lg ${
          props.isVisible ? 'ml-4 mr-4 translate-x-0' : '-translate-x-full'
        }`}
      >
        <p className="p-4">
          Hai aggiunto{' '}
          <span className="font-semibold">{props.addedProductName}</span> al
          carrello
        </p>
      </div>
    </div>,
    document.body
  )
}
